import { catalog } from '@nolens/i18n';

export const authText = catalog(
  {
    signIn: 'Sign in',
    signInHint: "Your guides and your team's, on any computer.",
    google: 'Continue with Google',
    or: 'or',
    email: 'Email',
    sendCode: 'Send code',
    termsLead: 'By continuing you accept the',
    termsOfUse: 'terms of use',
    and: 'and the',
    privacyPolicy: 'privacy policy',
    enterCode: 'Enter the code',
    codeSent: (email: string) =>
      `We sent a code to ${email}. Use the one in the most recent email.`,
    code: 'Code',
    otherEmail: 'Use another email',
    resendCode: 'Send a new code',
    tooSoon: 'Wait a minute before asking for another code.',
    googleError: "Couldn't open Google. Try again.",
    sendError: "Couldn't send the code. Check the email and try again.",
    codeError:
      'Wrong or expired code. Check that it is the one in the most recent email, or ask for a new one.',
    devTitle: 'Sign in (development)',
    devHint: 'Fictional seed accounts, with the local JWT secret.',
  },
  {
    'pt-PT': {
      signIn: 'Entrar',
      signInHint: 'Os seus guias e os da sua equipa, em qualquer computador.',
      google: 'Continuar com Google',
      or: 'ou',
      email: 'Email',
      sendCode: 'Enviar código',
      termsLead: 'Ao continuar aceita os',
      termsOfUse: 'termos de utilização',
      and: 'e a',
      privacyPolicy: 'política de privacidade',
      enterCode: 'Escreva o código',
      codeSent: (email) => `Enviámos um código para ${email}. Use o do email mais recente.`,
      code: 'Código',
      otherEmail: 'Usar outro email',
      resendCode: 'Enviar código novo',
      tooSoon: 'Espere um minuto antes de pedir outro código.',
      googleError: 'Não foi possível abrir o Google. Tente outra vez.',
      sendError: 'Não foi possível enviar o código. Confirme o email e tente outra vez.',
      codeError:
        'Código errado ou expirado. Confirme que é o do email mais recente, ou peça um novo.',
      devTitle: 'Entrar (desenvolvimento)',
      devHint: 'Contas fictícias do seed, com o segredo JWT local.',
    },
  },
);
